// Returns the default landing page for a given user based on principal type & role.
// Employee / HOD              -> /me  (Employee mobile shell — Phase 15.11)
// Driver                      -> /driver
// logistics_manager           -> /lm  (LM mobile shell — Phase 15.10)
// senior_management / hod     -> /   (Admin dashboard — Phase 15.12)
// mis                         -> /checklist  (Checklist Activity)
// accounts                    -> /accounts/dashboard (when present, else /)
// Admin / HR / Unit Manager   -> /  (HR dashboard)
const ROLE_LANDING = {
  logistics_manager: "/lm",
  logistics_executive: "/logistics/hub",
  mis: "/checklist",
  accounts: "/accounts/dashboard",
  ea: "/ea/dashboard",
  // Phase 15.12 — Senior Management & HOD need admin-side visibility into
  // Recruitment, Advances, HR activity, dashboards etc. Land them on the
  // admin sidebar so they can see everything (they remain principal_type
  // 'employee' for self-service portal access too).
  senior_management: "/",
  hod: "/",
};

// Roles that, even when seeded as portal employees, are allowed to use the
// admin/AppLayout sidebar (Senior Management, HOD).
const ADMIN_CAPABLE_PORTAL_ROLES = new Set(["senior_management", "hod"]);

export function defaultRouteForUser(user) {
  if (!user) return "/login";
  // Drivers (employee category) get the mobile driver portal
  if (user.principal_type === "employee" && user.category === "driver") return "/driver";
  // ROLE_LANDING wins over portal fallback so admin-flavoured roles (ea, accounts,
  // senior_management, hod) that happen to also be seeded as employees still land
  // on their console.
  if (ROLE_LANDING[user.role]) return ROLE_LANDING[user.role];
  // Also honour the legacy is_senior_management boolean.
  if (user.is_senior_management) return "/";
  // Employee / Manager / SM → new mobile shell
  if (user.principal_type === "employee") return "/me";
  return "/";
}

// Used by ProtectedRoute to decide whether a portal-principal user can still
// access admin-only pages (because their role grants admin visibility).
export function canAccessAdmin(user) {
  if (!user) return false;
  if (user.principal_type === "user") return true;
  if (ADMIN_CAPABLE_PORTAL_ROLES.has(user.role)) return true;
  if (user.is_senior_management) return true;
  return false;
}

// True when the user is a self-service employee (not an admin in `users`).
export function isPortalUser(user) {
  return !!user && user.principal_type === "employee";
}
